import Button from 'react-bootstrap/Button';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../app/store';
import { AuthState, useAuth } from './auth';
import { signOut } from './authSlice';
import styles from './SigninButton.module.css';

interface SignInProps {
  onClick?: () => void;
}

function SignInButton(props: SignInProps) {
  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();

  const handleSignIn = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  const handleSignOut = () => {
    dispatch(signOut());
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <>
      {(auth.state !== AuthState.SignedIn) && <Button variant="link" className={`nav-link text-left ${styles.signinButton}`} href="/api/WamAuth?action=signin" onClick={handleSignIn}>Sign in</Button>}
      {(auth.state === AuthState.SignedIn) && <Button variant="link" className={`nav-link text-left ${styles.signinButton}`} onClick={handleSignOut}>Sign out</Button>}
    </>
  );
}

export default SignInButton;